import React from 'react';
import { AuthProvider, useAuth } from './components/auth/AuthContext';
import Login from './components/auth/Login';
import Dashboard from './pages/Dashboard'; // Tu dashboard actual

// Componente que decide qué mostrar basado en autenticación
const AppContent = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Mostrar pantalla de carga mientras verifica la sesión
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando...</p>
        </div>
      </div>
    );
  }

  // Si está autenticado muestra Dashboard, si no muestra Login
  return isAuthenticated() ? <Dashboard /> : <Login />;
};

// Componente principal de la aplicación
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;